import { error, json } from "@sveltejs/kit";
import { h as handleRequest } from "../../../../../../chunks/utils2.js";
import { b as sendLicenseVerifiedEmail } from "../../../../../../chunks/mailer.js";
import { g as get, L as LicenseCollection, U as UserCollection } from "../../../../../../chunks/firebase.js";
const GET = handleRequest(async ({ url, locals }) => {
  const { searchParams } = url;
  const email = searchParams.get("email");
  const code = searchParams.get("code");
  if (!email || !code) {
    return error(400, { message: "No email or code provided" });
  }
  const license = await get(LicenseCollection(), email);
  const success = license.data?.code === code;
  if (!success) return error(403, { message: "Unauthorized" });
  if (locals.user?.email !== email) return error(403, { message: "Unauthorized" });
  await sendLicenseVerifiedEmail(email);
  await UserCollection().doc(locals.user?.id).set(
    { license: "premium", trialAvailability: false, trialStartDate: null },
    { merge: true }
  );
  return json(
    {
      success
    },
    {
      status: success ? 200 : 403
    }
  );
});
export {
  GET
};
